// http://goo.gl/XkBrjD
var $export = require(48)
  , $values = require(70)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});